// import React from "react";
import Storage from "./storage.service";
import Settings from "./settings.service";
import Helpers from "../helpers/shared.helper";
import HTTP from "./http.service";
import Products from "./products.service";
import User from "./user.service";
import Numbers from "./numbers.service";
import Promotions from "./promotions.service";
import Summaries from "./summaries.service";
import Translations from "./translation.service";
import CONSTANTS from "./constants.service";
import * as variables from "../variables";
import { isArray } from "rxjs/internal-compatibility";
import Translation from "./translation.service";
import checkModule from "../views/shared/checkModule";
import planFG from "./planFg.service";

var Plans = {};
const { isPlanKw, isPlanKsa } = checkModule;
var service_types = "1,3,4,10";

Plans.getCITC = () => {
  Storage.set("citcErrorStatus", true, true);
  const config = {
    method: "get",
    url: `cms/citc_plan_cards_list_by_type?type=plan`,
    headers: {
      "Virgin-Lang": Translation.getCurrentLanguage()
    }
  };
  return HTTP(config);
};


Plans.savePredefinedPlan = (data) => {
  let config = {
    method: "post",
    url: "/plans/saved_plans",
    data: data,
    headers: {
      "accept-version": "v20",
    }
  }


  return HTTP(config);
};

Plans.getPAYGPlans = (available_plans) => {
  let payg = {};
  for (let type of Settings.order) {
    if (available_plans[type]) {
      for (let plan of Object.keys(available_plans[type])) {
        if (available_plans[type][plan]["ChargingType"] === "PAYG") {
          payg[type] = available_plans[type][plan];
          break;
        }
      }
    }
  }
  return payg;
};

Plans.savePlanWithPlanId = (data, streamingPromotionCode = null) => {
  return new Promise(async (resolve) => {
    const response = await Products.saveProduct(data?.product_code);
    if (response) {
      const result = await Plans.savePlan(data.plan_ids, data.product_code, streamingPromotionCode,);
      if (result) {
        setTimeout(() => {
          User.fetchFlowStatus().then(() => {
            resolve(true)
          }).catch(() => {
            resolve(false)
          })
        }, 2000);
      } else {
        resolve(false)
      }
    } else {
      resolve(false)
    }
  })
}

Plans.checkContentServices = (promotionList) => {
  const contnetService = Helpers.getStreaminService();
  let value = [];
  if (!promotionList || promotionList.length === 0) return value;
  if (!promotionList) return value;
  if (promotionList?.length) {
    promotionList.forEach((promotion) => {
      if (promotion?.Value && isPlanKsa) {
        let valueObj = typeof promotion?.Value === "string" ? JSON.parse(promotion?.Value) : promotion?.Value;
        promotion.Value = valueObj;
        if (valueObj?.Type && contnetService?.includes(valueObj?.Type?.toLowerCase())) {
          value.push(promotion);
        }
      }
      if (promotion?.Type && contnetService?.includes(promotion?.Type?.toLowerCase()) && isPlanKw) {
        value.push(promotion);
      }


    })
  }
  return value;
}
Plans.checkKeyPromotionPlan = (selectedCard) => {
  let contentServiceData = ""
  if (isPlanKw) {
    contentServiceData = selectedCard?.Plan
  }
  if (isPlanKsa) {
    contentServiceData = selectedCard?.Promotions
  }
  return contentServiceData;
}

Plans.getSumData = (dataList, vairableType, dataType) => {
  let sumValues = 0;

  if (dataList?.length) {
    dataList.forEach((item) => {
      if (item.Type.toString() === vairableType.toString()) {
        if (dataType === "gb") {
          sumValues = item.Value === -1 ? -1 : sumValues +
            Helpers.bytesToGBs(item.Value)
        } else if (dataType === "min") {
          sumValues = item.Value === -1 ? -1 : sumValues +
            Helpers.milisecondstoMinutes(item.Value)
        }
      }
    })
  }
  return sumValues;
};

Plans.checkContentServicesFromPlans = (plan) => {

  let value = [];
  if (plan?.Plan?.length) {
    plan.Plan.forEach((data) => {
      if (CONSTANTS.CONTENT_SERVICES.includes(data?.Type.toLowerCase())) {
        value.push(data);
      }
    })
  }
  return value;
}

Plans.checkContentServicesFromPromotions = (promotionList) => {
  const contentService = Helpers.getStreaminService();
  let value = [];
  if (!promotionList || promotionList.length === 0) return value;
  if (!promotionList) return value;
  if (promotionList?.length) {
    promotionList.forEach((promotion) => {
      if (promotion?.Value) {
        let valueObj = typeof promotion?.Value === "string" ? JSON.parse(promotion?.Value) : promotion?.Value;
        promotion.Value = valueObj;
        if (valueObj?.Type && contentService.includes(valueObj?.Type.toLowerCase())) {
          value.push(promotion);
        }
      }

    })
  }
  return value;
}

Plans.fetchAvailablePlans = (productCodes = "") => {
  let product_codes = productCodes ? productCodes : Storage.get("pre-defined-plan-selected-product-code",true,true);

  let offerAppliedPromoId = Storage.get("offer_applied_promotion_id", true)
  // product_codes = "6";
  let config = {
    method: "get",
    url:
      "/products/available_plans?product_codes=" +
      product_codes +
      "&service_types=" +
      service_types +
      "&include_Vanity_Plan=true" +
      "&include_optional_promotions=true",
    headers: {
      // "accept-version": "v18",
      "cache-control": "no-cache"
    }
  };
  if (offerAppliedPromoId?.length) {
    let promotionID = isArray(offerAppliedPromoId) ?
      offerAppliedPromoId.join(",") :
      offerAppliedPromoId;
    config = {
      method: "get",
      url: "/products/available_plans?product_codes=" +
        product_codes +
        "&service_types=" +
        service_types +
        "&include_Vanity_Plan=true" +
        "&include_optional_promotions=true" +
        "&promotion_codes=" + promotionID,
      headers: {
        // "accept-version": "v18",
        "cache-control": "no-cache"
      }
    };
  }
  return HTTP(config);
};

Plans.fetchPredefinedPlans = (active_product_code = "") => {
  let product_codes = "";
  if (active_product_code) {
    product_codes = active_product_code
  } else {
    let productCode = Storage.get("commitments_upfront");
    product_codes = productCode
      .map((product) => {
        return product.ProductId;
      })
      .join(",");
  }
  let config = {
    method: "get",
    url: "/products/predefined_bundles?include_optional_promotions=true&product_codes=" +
      product_codes,
  };
  return HTTP(config);
};

Plans.getPromoObject = (plan) => {
  if (plan["Promotions"] && plan["Promotions"] !== null) {
    return plan["Promotions"];
  }
  if (plan["PlanPromotions"] && plan["PlanPromotions"] !== null) {
    return plan["PlanPromotions"];
  }
  if (plan["Promotion"] && plan["Promotion"] !== null) {
    return plan["Promotion"];
  }
  return null;
};

Plans.getlanPromotions = (plan) => {
  if (plan["PlanPromotions"] && plan["PlanPromotions"] !== null) {
    return plan["PlanPromotions"];
  }
  return null;
};

Plans.calculatePriceforAvailablePlan = () => {
  let planSpecs = Storage.get("SelectedAvailablePlan");

  let plan = {};

  let pricing =
    Storage.get("pricingByProduct")["" + Storage.get("selectedProduct")];

  //@Todo
  if (planSpecs) {
    let price = {
      withVat: 0,
      noVat: 0,
    };

    let subs = [];

    for (let type of Object.keys(planSpecs)) {
      let subplan = planSpecs[type];
      subs.push(subplan.ID);

      price["withVat"] += subplan["Price"];
      price["noVat"] += subplan["PriceVATExc"];
    }

    let lookup = subs.sort().join(",");

    let vat_percentage = JSON.parse(Storage.get("business", true))[
      "vat_percentage"
    ];

    if (pricing[lookup]) {
      plan = pricing[lookup];
      plan = Plans.getSinglePlanWithSpecs(pricing[lookup]);
      plan["specs"] = planSpecs;

      plan["noVat"] = plan["Price"];
      plan["withVat"] = (
        plan["Price"] *
        ((100 + vat_percentage) / 100)
      ).toFixed(2);

      price["withVat"] = plan["withVat"];
      price["noVat"] = plan["noVat"];
    } else {
      plan = {
        DiscountedPriceVATExc: price["noVat"],
        Plans: subs,
        Price: price["noVat"],
        Promotions: null,
        lookup: lookup,
      };
    }

    Storage.set("AvailablePlanObj", plan);
    Storage.set("AvailablePlanPrice", price);
  } else {
    Storage.set("AvailablePlanObj", null);
    Storage.set("AvailablePlanPrice", null);
  }
};

Plans.getActiveProductCode = async () => {
  // Synced
  let API = null
  switch (Settings.get("version")) {
    case '_kw_onboard':
      API = Products.fetchAllActiveProductsCode
      break;
    case "_ksa":
      API = Products.fetchAllActiveProductsCodeKsa
      break;
    default:
      API = Products.fetchAllActiveProductsCodeKsa
  }
  try {
    const response = await Storage.getOrfetch("OldActiveProductCodes", API);
    let responsekey = null
    switch (Settings.get("version")) {
      case '_kw_onboard':
        responsekey = response.data
        break;
      case "_ksa":
        responsekey = response.data.ListProduct
        break;
      default:
        responsekey = response.data.ListProduct
    }
    if (response && responsekey) {
      const activeProductCodes = responsekey.map(product => product.ProductCode);
      Storage.set("ActiveProductCodes", activeProductCodes.join(), true);
      Storage.set("ActiveProductCodes", activeProductCodes.join());
      Storage.set("ActiveProductPlans", responsekey);
      return responsekey;
    } else {
      console.error("Error: Response or data is empty in fetchActiveProductCodes");
      return null;
    }
  } catch (error) {
    console.error(error);
  }
};

Plans.saveBundleFromParams = (data, streamingPromotionCode = null) => {
  Storage.set("wp_loader", true);
  return new Promise(async (resolve) => {
    const response = await Products.saveProduct(data?.product_code);
    if (response) {
      const result = await Plans.savePlan(data?.plan_ids, data?.product_code);
      if (result) {
        setTimeout(() => {
          User.fetchFlowStatus().then(() => {
            resolve(true)
          }).catch(() => {
            resolve(false)
            Storage.set("wp_loader", false);
          })
        }, 2000);
      } else {
        resolve(false)
        // Storage.set("wp_loader", false);
      }
    } else {
      resolve(false)
      Storage.set("wp_loader", false);
    }
  })

  // Plans.getPlans("Available");

  // Storage.get_obsrv("AvailablePlans").subscribe(data => {
  //  if (data) {
  //      Plans.getPlans("Predefined");
  //  }
  // });

  // Storage.get_obsrv("PredefinedPlans").subscribe(data => {
  //  if (data) {
  //      let bundle = data[bundle_id];
  //      if (bundle && !Storage.get('calling_saveProductAndBundle')) {
  //          alert('999')
  //          let f = Plans.saveProductAndBundle(bundle);
  //          Storage.set('calling_saveProductAndBundle', f);

  //          f
  //              .then(response => {
  //                  Summaries.init('storage_params["bundle_id"]');
  //                  User.fetchFlowStatus(11);
  //              })
  //              .catch(error => {
  //                  // Errors.redirectAfterError();
  //              });
  //      } else {
  //          // Errors.redirectAfterError();
  //      }
  //  }
  // });


};

Plans.savePlanFromParams = (plan_ids, streamingPromotionCode = null) => {
  return Plans.getProducts()
    .then((response) => {
      Storage.set("selectedPlanSpecsIDs", plan_ids);
      Storage.set("promotionCodes", streamingPromotionCode);
      return Plans.saveProductAndCustomPlan()
        .then((response) => {
          Summaries.init('storage_params["plan_ids"]');
          const streamData = Storage.get("StreamModal");
          if (
            streamData?.TYPE === "STORAGE_PARAMS_CUS" ||
            streamData?.TYPE === "STORAGE_PARAMS_PRD_PLAN_IDs"
          ) {
            Storage.set("StreamModal", {});
            return;
          }
          User.fetchFlowStatus(10);
        })
        .catch((error) => {
          // Errors.redirectAfterError();
        });
    })
    .catch((error) => {
      // Errors.redirectAfterError();
    });
};

Plans.getProducts = () => {
  return Storage.getOrfetch("Products", Products.fetchAllProducts) // fetchProducts //fetchAllProducts
    .then((response) => {
      if (response) {
        if (response.data && response.data["list_product"]) {
          // 2. process products
          Storage.set(
            "Products",
            Products.processProducts(response.data["list_product"])
          );

          Storage.set(
            "selectedProduct",
            response.data["list_product"][0]["ProductCode"]
          );
        }
      }
    })
    .catch((error) => { });
};

Plans.findPlanType = (PredefinedPlans, plan) => {
  let ids = [];

  // 1. get predefined plans ids
  let bundles_keys = Object.keys(PredefinedPlans);
  for (let bundle_key of bundles_keys) {
    let combination = Plans.getPlanIDs(PredefinedPlans[bundle_key]);
    ids.push(combination);
  }

  // 2. get plan ids
  let plan_combination = Plans.getPlanIDs(plan);

  // 3. compare
  if (ids.indexOf(plan_combination) !== -1) {
    return "PRD";
  } else {
    return "CUS";
  }
};

Plans.getPlans = (type, forceFetch = false) => {
  return Plans.getProducts()
    .then((response) => {
      // 3. get plans
      return Storage.getOrfetch(
        type + "Plans",
        Plans["fetch" + type + "Plans"],
        forceFetch
        // true
      )
        .then((response) => {
          // 3. process plans
          // if (!Storage.get("AvailablePlans")) {
          // Storage.set("PackagesPricingTable",JSON.stringify(response.data?.AvailablePlansWithPackagesPricing[0]?.PackagesPricingTable))

          Plans["process" + type + "Plans"](response.data);
          if (type === "Available") {
            Storage.set("AvailablePlansWithPackagesPricing", response.data);

            Storage.set(
              "available_plans",
              response.data.AvailablePlansWithPackagesPricing[0].AvailablePlans
            );
            const { AvailablePlansWithPackagesPricing: APPP } = response.data;

            const ntlData = APPP[0].AvailablePlans.filter(
              (item) => item.Type === "VOICE-LCL" && Math.ceil(item.Value) > 0
            ).map((plan) => ({
              planId: plan.ID,
              value: Helpers.milisecondstoMinutes(plan.Value),
              price: plan.Price,
            }));

            const intlData = APPP[0].AvailablePlans.filter(
              (item) => item.Type === "VOICE-INT"
            ).map((plan) => ({
              planId: plan.ID,
              value: Helpers.milisecondstoMinutes(plan.Value),
              price: plan.Price,
            }));

            const dataInGB = APPP[0].AvailablePlans.filter(
              (item) => item.Type === "DATA" && Math.ceil(item.Value) > 0
            ).map((plan) => ({
              planId: plan.ID,
              value: Helpers.bytesToGBs(plan.Value),
              price: plan.Price,
            }));

            Storage.set("localCalling", ntlData);
            Storage.set("dataPack", dataInGB);
            Storage.set("internationalCalling", intlData);

            let pricingArray = [];
            APPP.forEach((item) => {
              const priceObject = {
                productCode: item.ProductCode,
                packagesPricingTable: item.PackagesPricingTable,
              };

              pricingArray.push(priceObject);
            });
            Storage.set("PackagesPricingTable", pricingArray);
          }

          // }
        })
        .catch((error) => { });
    })
    .catch((error) => { });

  // 1. get products
};

Plans.getPlansForStream = (type) => {
  return Plans.getProducts()
    .then((response) => {
      // 3. get plans
      return Storage.getOrfetch(
        type + "Plans",
        Plans["fetch" + type + "Plans"]
        // true
      )
        .then((response) => {
          // 3. process plans
          // if (!Storage.get("AvailablePlans")) {
          // Storage.set("PackagesPricingTable",JSON.stringify(response.data?.AvailablePlansWithPackagesPricing[0]?.PackagesPricingTable))
          Plans["process" + type + "Plans"](response.data);
          // }
        })
        .catch((error) => { });
    })
    .catch((error) => { });

  // 1. get products
};

Plans.processAvailablePlans = (data, save = true) => {
  // let vat_factor = parseFloat(Globals.get("vat_factor"));
  // Storage.set("SelectedAvailablePlan", {});
  const responseArray = Array.isArray(data.AvailablePlansWithPackagesPricing);
  if (
    !responseArray ||
    (responseArray && !data.AvailablePlansWithPackagesPricing.length)
  ) {
    throw new Error("array_not_exist_in_response");
  }
  let pricingLookupArr =
    data.AvailablePlansWithPackagesPricing[0].PackagesPricingTable.map(
      (itm) => {
        let item = itm;
        item["lookupID"] = itm.Plans.sort().join(",");
        return item;
      }
    );

  let pricingLookupObj = Helpers.arrayToObject(pricingLookupArr, "lookupID");
  Storage.set("pricing", pricingLookupObj);

  let pricingByProduct = Storage.get("pricingByProduct");

  if (!pricingByProduct) {
    pricingByProduct = {};
  }

  pricingByProduct[Storage.get("selectedProduct")] = pricingLookupObj;

  Storage.set("pricingByProduct", pricingByProduct);
  Storage.set(
    "PackagesPricingTable",
    data?.AvailablePlansWithPackagesPricing[0]?.PackagesPricingTable
  );

  let customPlansByType = {};
  let plans = data.AvailablePlansWithPackagesPricing[0]["AvailablePlans"].sort(
    Helpers.sortByPrice
  );
  let plan_types = [];

  for (let plan of plans) {
    let ID = plan.PlanID ? plan.PlanID : plan.ID;

    if (plan_types.indexOf(plan.Type) === -1) {
      plan_types.push(plan.Type);
      customPlansByType[plan.Type] = {};
    }

    if (plan.Unit === "bytes") {
      plan["Formatted"] = Helpers.bytesToGBs(plan.Value);
      plan["FormattedUnit"] = "GB";
      plan["FormattedUnitLokaliseKey"] = "general_plan_units_gb";

      plan["Extra"] = 0;
      if (plan["IsEligibleForDataDoubling"]) {
        plan["Extra"] += plan["Formatted"];
      }
    }

    if (plan.Unit === "milliseconds") {
      plan["Formatted"] = Helpers.milisecondstoMinutes(plan.Value);
      plan["FormattedUnit"] = "min";
      plan["FormattedUnitLokaliseKey"] = "general_plan_units_minute_short";
    }

    customPlansByType[plan.Type][ID] = plan;
  }

  Storage.set("plan_types", plan_types);

  let excluded = Settings.excluded_plan_types.split(",");
  let keys = {};

  for (let type of plan_types) {
    if (excluded.indexOf(type) === -1) {
      keys[type] = Object.keys(customPlansByType[type]);
      let count = keys[type].length;
      let active = Math.floor(count / 2);
      Plans.selectAvailableSpec(customPlansByType[type][keys[type][active]]);
    }
  }

  if (save) {
    Storage.set("AvailablePlans", customPlansByType);
  }

  return customPlansByType;
};

Plans.addVanityPlan = (predefinedPlans) => {
  let flags = Storage.get("flags");
  if (Plans.addingVanity) {
    return;
  }

  Plans.addingVanity = true;
  let sub1 = null;
  let sub2 = null;

  let plans = { ...predefinedPlans };

  sub1 = Storage.get_obsrv("AvailablePlans").subscribe((AvailablePlans) => {
    if (AvailablePlans) {
      let number = Storage.get("reserved_number");

      let vanity_detail = Numbers.getNumberDetailsFromVanity(number);
      if (Numbers.isPremiumNumber(number)) {
        vanity_detail["is_vanity_plan"] = true;
        let vanity_plan = Plans.getSinglePlanWithSpecs(vanity_detail);
        if (vanity_plan) {
          vanity_plan["PaygPlans"] = Plans.getPAYGPlans(AvailablePlans);
          plans["vanity_plan"] = vanity_plan;
          Plans.addingVanity = false;
          Storage.set("PredefinedPlansWithVanity", plans);
          if (sub1) sub1.unsubscribe();
          if (sub2) sub2.unsubscribe();
        } else {
          Plans.addingVanity = false;
          Storage.set("PredefinedPlansWithVanity", plans);
          if (sub1) sub1.unsubscribe();
          if (sub2) sub2.unsubscribe();
        }
      } else {
        Plans.addingVanity = false;
        Storage.set("PredefinedPlansWithVanity", plans);
        if (sub1) sub1.unsubscribe();
        if (sub2) sub2.unsubscribe();
      }
    }
  });

  if (flags.NumberSelected) {
    sub2 = Storage.get_obsrv("reserved_number").subscribe((number) => {
      if (number) {
        if (Numbers.isPremiumNumber(number)) {
          // Plans.getPlans("Available");
          if (!Storage.get("Available") && !Storage.get("Products")) {
            Plans.getPlans("Available");
          }
        } else {
          Plans.addingVanity = false;
          Storage.set("PredefinedPlansWithVanity", plans);
          if (sub1) sub1.unsubscribe();
          if (sub2) sub2.unsubscribe();
        }
      }
    });
  } else {
    Plans.addingVanity = false;
    Storage.set("PredefinedPlansWithVanity", plans);
    if (sub1) sub1.unsubscribe();
    if (sub2) sub2.unsubscribe();
  }
};

Plans.processPredefinedPlans = (data, save = true) => {
  let plans = data["PreDefinedBundles"][0]["PreDefinedBundle"];
  Plans.getPlanWithSpecs(plans);

  let plansLength = plans.length;
  let heroPlanIds = [];
  for (let i = 0; i < plansLength; i++) {
    if (plans[i].Name === "Hero") {
      heroPlanIds = [plans[i].Plan[0].PlanID, plans[i].Plan[1].PlanID];
      Storage.set("heroPlanIds", heroPlanIds);
      break;
    }
  }

  if (save) {
    Storage.set("PredefinedPlans", plans);
  }

  return plans;
};

// Plans.checkContentServices = (promotionList) => {
//   const contnetService = Helpers.getStreaminService();
//   let value = [];
//   if (!promotionList || promotionList.length === 0) return value;
//   if (!promotionList) return value;
//   if (promotionList?.length) {
//     promotionList.forEach((promotion) => {
//       if (promotion?.Value) {
//         let valueObj = typeof promotion?.Value === "string" ? JSON.parse(promotion?.Value) : promotion?.Value;
//         promotion.Value = valueObj;
//         if (valueObj?.Type && contnetService?.includes(valueObj?.Type?.toLowerCase())) {
//           value.push(promotion);
//         }
//       }

//     })
//   }
//   return value;
// }

Plans.selectAvailableSpec = (item) => {
  let selectedPlan = { ...Storage.get("SelectedAvailablePlan") };
  selectedPlan[item.Type] = item;
  Storage.set("SelectedAvailablePlan", selectedPlan);
  Storage.set("SelectedAvaialblePromotion");
  Plans.calculatePriceforAvailablePlan();
};

Plans.processUserSelectionFromStorageParams = (storage_params, planData) => {
  Storage.set("wp_loader", true);
  let planIds = storage_params["plan_ids"];
  let bundleId = storage_params["bundle_id"];
  let productCode = storage_params["product_code"];
  let planType = storage_params["plan_type"]
  if (planType === "PRD-FG" && storage_params["fg_product_code"]) {
    productCode = storage_params["fg_product_code"];
  }
  if (planData?.length) {
    planData.forEach((ele) => {
      if (Number(ele?.ProductCode) === Number(productCode)) {
        Storage.set(
          "FgPredefinedPlanData",
          JSON.stringify(ele.PreDefinedBundle),
          true
        );
        // Storage.set("FgPredefinedPlanData", response.data.PreDefinedBundles, true);
        Storage.set("selectedProduct", productCode, true);
        if (ele.PreDefinedBundle?.length) {
          for (let plan of ele.PreDefinedBundle) {
            if (Number(plan.ID) === Number(bundleId)) {
              let data = {
                plan_ids: planIds,
                product_code: productCode,
                promotion_codes: ""
              }
              Storage.set(
                "selectedPlanData",
                JSON.stringify(plan),
                true
              );
              Storage.set("is_web_category_selected", true, true);
              Storage.set("choose_plan_category", true, true);
              Storage.set("is_predefined_selected", true, true);
              Storage.set("plan_type", storage_params["plan_type"], true);
              let plan_type = planType === "PRD-FG" ? "SAVE_PREDEFINED_FG" : "STORAGE_PARAMS_PRD_BUNDLE";
              let sixAvailablePromotions = Plans.checkContentServices(plan?.Promotions);
              if (sixAvailablePromotions?.length) {

                Storage.set("StreamModal",
                  {
                    'SHOW': true,
                    'TYPE': plan_type,
                    'Plan_type': "WP_PLAN",
                    'PLAN': data,
                    'content_list': sixAvailablePromotions
                  });
              } else {
                let API = null
                if (planType === "PRD-FG") {
                  API = planFG.saveFGplan
                } else {
                  API = Plans.saveBundleFromParams
                }
                let data = {
                  product_code: productCode,
                  plan_ids: planIds
                }
                API(data)
                  .then(response => {
                    User.fetchFlowStatus(4).then(res => {
                      Storage.set("wp_loader", false);
                    }).catch(res => {
                      Storage.set("wp_loader", false);
                    })
                  }).catch(res => {
                    Storage.set("wp_loader", false);
                  })

              }
            } else {
              Storage.set("wp_loader", false);
            }
          }

        }

      }
    })
  } else {
    Storage.set("wp_loader", false);
  }

}


Plans.getPlanWithSpecs = (plans) => {
  let plan_with_specs = {};
  for (let plan of plans) {
    let ID = plan.PlanID ? plan.PlanID : plan.ID;
    // if (!ID) {
    //  ID = "vanity_plan";
    // }\
    if (plan.Name !== "Social") {
      plan_with_specs[ID] = Plans.getSinglePlanWithSpecs(plan);
    }
  }
  return plan_with_specs;
};

Plans.getCustomPlanWithSpecs = (plans) => {
  let plan_with_specs = {};
  for (let index in plans) {
    let plan = plans[index];
    let ID = plan.PlanID ? plan.PlanID : plan.ID;
    if (plan.Name !== "Social") {
      plan_with_specs[ID] = Plans.getSinglePlanWithSpecs(plan);
    }
  }
  return plan_with_specs;
};

Plans.getCustomPlanPromotions = (
  plan,
  packagePricingTable,
  plan_ids = false
) => {
  let lookupIds = [];
  let lookupIdsString = "";
  if (!plan_ids) {
    for (let item in plan) {
      lookupIds.push(plan[item].PlanID ? plan[item].PlanID : plan[item].ID);
      lookupIdsString = lookupIds.sort().join(",");
    }
  } else {
    lookupIdsString = plan_ids.split(",").sort().join(",");
  }

  for (let item in packagePricingTable) {
    if (packagePricingTable[item].lookupID === lookupIdsString) {
      return packagePricingTable[item].Promotions;
    }
  }

  return null;
};

Plans.checkCustomPlanIds = (packagePricingTable, plan_ids) => {
  let lookupIdsString = plan_ids.split(",").sort().join(",");
  for (let item in packagePricingTable) {
    if (packagePricingTable[item].lookupID === lookupIdsString) {
      return true;
    }
  }

  return false;
};

Plans.getAnghamiAndStarzplayPromotions = (promotionList) => {
  if (!promotionList || promotionList.length === 0) return null;
  if (!promotionList) return null;
  let anghamiPromotion = null;
  let starzPlayPromotion = null;
  for (let promotion in promotionList) {
    try {
      let valueObj = JSON.parse(promotionList[promotion].Value);
      if (valueObj.Type === "ANGHAMI")
        anghamiPromotion = promotionList[promotion];
      if (valueObj.Type === "STARZPLAY")
        starzPlayPromotion = promotionList[promotion];
    } catch (e) {
      // console.log("Cannot parse value object")
    }
  }
  if (anghamiPromotion || starzPlayPromotion) {
    return {
      [variables.ANGHAMI_PROMOTION]: anghamiPromotion,
      [variables.STARZPLAY_PROMOTION]: starzPlayPromotion,
    };
  }

  return null;
};

Plans.clear = () => {
  Storage.set("promotions", null);
  Storage.set("promotions_result", null);
};

Plans.getSinglePlanWithSpecs = (plan) => {
  let plan_specs = {};
  let plan_list = plan["Plan"] ? plan["Plan"] : plan["Plans"];
  let subplans = [];
  let result = false;

  if (plan && plan_list.length) {
    let test = JSON.stringify(plan_list);
    if (test.indexOf("{") === -1) {
      // ids not objects

      let new_plan_list = [];

      let AvailablePlans = Storage.get("AvailablePlans");
      if (AvailablePlans) {
        for (let id of plan_list) {
          for (let type of Settings.order) {
            if (AvailablePlans[type]) {
              let keys = Object.keys(AvailablePlans[type]);
              if (keys.indexOf(id + "") !== -1) {
                new_plan_list.push(AvailablePlans[type][id]);
                break;
              }
            }
          }
        }

        plan_list = new_plan_list;
      }
    }

    for (let plan_spec of plan_list) {
      if (isNaN(plan_spec)) {
        let ID = plan_spec.PlanID ? plan_spec.PlanID : plan_spec.ID;
        plan_spec["ID"] = ID;
        subplans.push(ID);
      }
    }
  }

  plan["lookupID"] = subplans.sort().join(",");

  let avail_plan =
    Storage.get("pricingByProduct")[Storage.get("selectedProduct")][
    plan["lookupID"]
    ];

  let promotions = [];

  if (avail_plan && !plan["is_vanity_plan"]) {
    let plan_promotions = Promotions.getPromotionsByPlan(avail_plan);

    let user_promotions = Storage.get("promotions");
    promotions = Promotions.combinePromotions(user_promotions, plan_promotions);
    if (promotions) {
      result = Promotions.calculateAllPromotions(promotions, avail_plan);
      plan["Promotions"] = promotions;
    }

    // if(result){
    //  plan['promos'] = [];
    // }
  }

  if (plan && plan_list.length) {
    for (let plan_spec of plan_list) {
      if (plan_spec.Type === "DATA") {
        if (!plan["is_vanity_plan"]) {
          plan_spec["Formatted"] = Helpers.bytesToGBs(plan_spec.Value);
        } else {
          plan_spec["Formatted"] = plan_spec.Value;
        }

        plan["FormattedUnit"] = "GB";
        plan["FormattedUnitLokaliseKey"] = "general_plan_units_gb";
        let extra = 0;

        if (result && result.extraDataFormatted) {
          extra = result.extraDataFormatted;
        }

        plan_spec["extra"] = extra;
        plan["extraDataFormatted"] = extra;
      }

      if (plan_spec.Type === "VOICE-LCL") {
        if (!plan["is_vanity_plan"]) {
          plan_spec["Formatted"] = Helpers.milisecondstoMinutes(
            plan_spec.Value
          );
        } else {
          plan_spec["Formatted"] = plan_spec.Value;
        }

        let extra = 0;

        if (result && result.extraLocalFormatted) {
          extra = result.extraLocalFormatted;
        }

        plan_spec["extra"] = extra;
        plan["extraLocalFormatted"] = extra;

        plan["FormattedUnit"] = "min";
        plan["FormattedUnitLokaliseKey"] = "general_plan_units_minute_short";
      }

      if (plan_spec.Type === "VOICE-INT") {
        if (!plan["is_vanity_plan"]) {
          plan_spec["Formatted"] = Helpers.milisecondstoMinutes(
            plan_spec.Value
          );
        } else {
          plan_spec["Formatted"] = plan_spec.Value;
        }

        let extra = 0;

        if (result && result.extraInternationalFormatted) {
          extra = result.extraInternationalFormatted;
        }

        plan_spec["extra"] = extra;
        plan["extraInternationalFormatted"] = extra;

        plan["FormattedUnit"] = "min";
        plan["FormattedUnitLokaliseKey"] = "general_plan_units_minute_short";
      }

      plan_specs[plan_spec.Type] = plan_spec;
    }

    plan["subplans"] = subplans.sort(Helpers.sortDefault);

    plan["specs"] = plan_specs;

    // plan['save_percentage'] = (promotions) && )

    //plan["OriginalPrice"] !== plan["DiscountedPrice"]? plan["DiscountedPrice"] / plan["OriginalPrice"] * 100: 0;

    if (plan["IsPopular"]) {
      Storage.set("popular_plan_id", plan["ID"]);
    }
  } else {
    plan = null;
  }

  return plan;
};

Plans.saveProductAndCustomPlan = () => {
  return Products.saveProduct()
    .then((response) => {
      return Plans.savePlan();
    })
    .catch((error) => { });
};

Plans.saveProductAndNoPlan = (streamingPromotionCode = null) => {
  Storage.set("promotionCodes", streamingPromotionCode);
  return Products.saveProduct()
    .then((response) => {
      let payg_ids = JSON.parse(Storage.get("business", true))[
        "just_sim_plans_ids"
      ].join(",");
      return Plans.savePlan(payg_ids);
    })
    .catch((error) => { });
};

Plans.isPAYG = (data) => {
  if (data && data.DATA && data["VOICE-LCL"])
    return data.DATA.Value === 0 && data["VOICE-LCL"].Value === 0;
  return false;
};

Plans.saveProductAndBundle = (bundle = null, streamingPromotionCode = null) => {
  if (Storage.get("calling_saveProductAndBundle")) {
    return Storage.get("calling_saveProductAndBundle");
  }

  if (bundle) {
    Storage.set("selectedPlanSpecsIDs", Plans.getPlanIDs(bundle));
    Storage.set("promotionCodes", streamingPromotionCode);
  } else {
    let selectedPlan = {
      specs: Storage.get("SelectedAvailablePlan"),
    };
    Storage.set("selectedPlanSpecsIDs", Plans.getPlanIDs(selectedPlan));
    Storage.set("promotionCodes", streamingPromotionCode);
  }

  return Products.saveProduct()
    .then((response) => {
      return Plans.savePlan()
        .then((resp) => {
          Plans.getSelectedBundle();
        })
        .catch((err) => { });
    })
    .catch((error) => { });
};
if (!Array.isArray) {
  Array.isArray = function (arg) {
    return Object.prototype.toString.call(arg) === "[object Array]";
  };
}
Plans.getPlanIDs = (selectedPlan, format = false) => {
  let plansListArray = [];
  let separator = format ? "|" : ",";

  let source = "specs";

  if (Array.isArray(selectedPlan) && selectedPlan.length === 0) {
    return "0" + separator + "0";
    // source = "PaygPlans";
  }

  let keys = Object.keys(selectedPlan[source]);
  let used = keys;

  if (format) {
    let ordered = Settings.order;
    used = ordered;
  }

  for (let subplanKey of used) {
    if (keys.indexOf(subplanKey) !== -1) {
      let subplan = selectedPlan[source][subplanKey];
      let ID = subplan.PlanID ? subplan.PlanID : subplan.ID;
      if (format) {
        plansListArray.push(subplan.Formatted);
      } else {
        plansListArray.push(ID);
      }
    }
  }

  return plansListArray.join(separator);
};

Plans.getCustomPlanIDs = (selectedPlan, format = false) => {
  let plansListArray = [];
  let separator = format ? "|" : ",";

  let ordered = Settings.order;
  let keys = Object.keys(selectedPlan);
  let used = keys;
  if (format) {
    used = ordered;
  }
  for (let type of used) {
    if (keys.indexOf(type) !== -1) {
      let subplan = selectedPlan[type];
      if (type === "DATA") {
        plansListArray.push(Helpers.bytesToGBs(subplan.Value));
      } else if (type === "VOICE-LCL" || type === "VOICE-INT") {
        plansListArray.push(Helpers.milisecondstoMinutes(subplan.Value));
      }
    }
  }

  return plansListArray.join(separator);
};

Plans.getSelectedBundle = () => {
  // Storage.set("should_select_plan", null, true)

  Storage.getOrfetch("selected_bundle", Plans.getSavedBundle, true)
    .then((response) => {
      if (response.data) {
        let selected_bundle = null;
        let saved = response.data.save_plans[0];
        // User.fetchFlowStatus(10);
        if (saved) {
          selected_bundle = Plans.getSinglePlanWithSpecs(saved);
          //@Todo? Get id of this combination if needed
        } else {
          selected_bundle = null;
        }

        Storage.set("selected_bundle", selected_bundle);
      }
    })
    .catch((error) => { });
};

Plans.getSavedBundle = (callee = "default") => {
  // Storage.set("should_select_plan", null, true)

  let config = {
    method: "get",
    // url: "/plans/saved_plans&random=" + Date.parse(new Date())
    url: "/plans/saved_plans",
  };
  return HTTP(config);
};

Plans.savePlan = (plan_ids = null, productCode, promotion_codes = null) => {
  let config = {
    method: "post",
    url: "/plans/saved_plans",
    data: {
      is_5g: false,
      plan_ids: plan_ids,
      product_code: productCode || Storage.get("selectedProduct"),
      promotion_codes: promotion_codes
        ? promotion_codes
        : Storage.get("promotionCodes"),
    },
    headers: {
      "accept-version": isPlanKw ? "v20" : "v24",
      "cache-control": "no-cache"
    }
  };
  return HTTP(config);
};

Plans.renewPlan = (plan_ids = null, promotion_codes = null) => {
  let config = {
    method: "put",
    url: "/plans",
    data: {
      new_plan_ids: plan_ids ? plan_ids : Storage.get("selectedPlanSpecsIDs"),
      product_code: Storage.get("selectedProduct"),
      promotion_codes: promotion_codes
        ? promotion_codes
        : Storage.get("promotionCodes"),
      number: Storage.get("reserved_number")["MSISDN"],
    },
  };
  return HTTP(config);
};

Plans.postPlanExtras = (extras = null) => {
  let config = {
    method: "post",
    url: "/extras",
    data: {
      extras: extras
        ? JSON.stringify(extras)
        : JSON.stringify(Storage.get("extras")),
    },
  };
  return HTTP(config);
};

Plans.getPlanPromotionImage = (
  promotionImages,
  promotion_type,
  promotion_id
) => {
  if (promotionImages) {
    return (
      promotionImages[
      promotion_type + promotion_id + "_" + Translations.activeLang
      ] &&
      promotionImages[
      promotion_type + promotion_id + "_" + Translations.activeLang
      ]["url"]
    );
  }
};

//Return available promotion
Plans.getAvailablePromotions = (selectedService = false, promotions = []) => {
  if (selectedService) {
    if (selectedService === variables.PROMOTION_TYPE_ANGHAMI) {
      return promotions[variables.STARZPLAY_PROMOTION];
    } else if (selectedService === variables.PROMOTION_TYPE_STARZPLAY) {
      return promotions[variables.ANGHAMI_PROMOTION];
    }
  }

  return false;
};

if (
  Settings.version &&
  (Settings.version === "_kuwait" || Settings.version === "_kw_onboard")
) {
  Plans.proccessVanityNumberDataKW = (vanitiLevel) => {
    let style = {};
    let theme = Storage.get("theme", true);
    let vanity_theme = Settings.get("vanity_theme");
    let theme_parsed = JSON.parse(theme);
    let vanity_details = Storage.get("vanity_details");
    let vanity_name = vanity_details[vanitiLevel]["Name"];
    let vanity_price = vanity_details[vanitiLevel]["Price"];
    let nameKey = Settings.get("common_general_vanity_name") + vanity_name;
    let subnameKey = Settings.get("vanity_name_subname_kw") + vanity_name;
    // let name = Translations.keys[name_key];
    // let subname=Translations.keys[subname_key];
    let style_value = null;
    if (theme && vanity_theme && theme_parsed) {
      let style_value_comp = vanity_theme + vanity_name;
      if (style_value_comp) {
        style_value = theme_parsed[style_value_comp];
        style["color"] = style_value;
      }
    }
    return { nameKey, subnameKey, style_value, vanity_price };
  };
}

Plans.sortPlansTypeSequence = (originalPlanData, promotionsData) => {

  // Filter the transformed data based on AVAILABLE_PLAN_TYPES
  const seenTypes = new Set();
  const plansData = originalPlanData.filter(plan => {
      if (CONSTANTS.AVAILABLE_PLAN_TYPES.includes(plan.Type) && !seenTypes.has(plan.Type)) {
          seenTypes.add(plan.Type);
          return true;
      }
      return false;
  });
  
  const planTypeSequence = () => {
    const plan_type_sequence = Helpers.getPOValue("plan_type_sequence", [])
    return plan_type_sequence
  }

  const { dataSocialPromotion, restOfThePromotions } = Plans.planPromotionFilter(promotionsData);

  if (dataSocialPromotion) {
    plansData.unshift(dataSocialPromotion);
  }

  // Create a map from planType to its index in the sequence
  const typeIndexMap = planTypeSequence().reduce((map, type, index) => {
      map[type] = index;
      return map;
  }, {});

  // Separate plans into recognized and unrecognized
  const recognizedPlans = [];
  const unrecognizedPlans = [];

  plansData.forEach(plan => {
      if (typeIndexMap.hasOwnProperty(plan.Type)) {
          recognizedPlans.push(plan);
      } else {
          unrecognizedPlans.push(plan);
      }
  });

  // Sort recognized plans based on type index
  const sortedRecognizedPlans = recognizedPlans?.sort((a, b) => {
      return typeIndexMap[a.Type] - typeIndexMap[b.Type];
  });

  // Concatenate sorted recognized plans with unrecognized plans
  const sortedData = sortedRecognizedPlans?.concat(unrecognizedPlans);


  // Map to include only the specified keys
  const transformedData = sortedData?.map(plan => ({
    Type: plan?.Type,
    Value: plan?.Value,
    Unit: plan?.Unit,
  }));

  // Separate out zero-value items
  const zeroValueItems = transformedData.filter(plan => plan.Value === 0);
  const nonZeroValueItems = transformedData.filter(plan => plan.Value !== 0);  
  
  // Now Filter Data-Social items and check if any of it is -1 then keep the -1

  // Check if there's any DATA-SOCIAL plan with Value: -1
  const hasDataSocialWithNegativeValue = nonZeroValueItems.some(plan => 
    plan.Type === "DATA-SOCIAL" && plan.Value === -1
  );

  const filteredNonZeroValueItemsData = nonZeroValueItems.reduce((acc, plan) => {
    // Check if plan is DATA-SOCIAL
    if (plan.Type === "DATA-SOCIAL") {
        // If there is a DATA-SOCIAL plan with Value -1
        if (hasDataSocialWithNegativeValue) {
            // Only keep DATA-SOCIAL plans with Value -1
            if (plan.Value === -1) {
                acc.push(plan);
            }
        } else {
            // No DATA-SOCIAL plans with Value -1
            // Sum the VALUE for DATA-SOCIAL plans
            const existingPlan = acc.find(p => p.Type === "DATA-SOCIAL");
            if (existingPlan) {
                // Update the existing plan's VALUE
                existingPlan.Value += plan.Value;
            } else {
                // Add the new DATA-SOCIAL plan
                acc.push({ ...plan });
            }
        }
    } else {
        // Add non-DATA-SOCIAL plans as they are
        acc.push(plan);
    }
    return acc;
  }, []);


  const firstRowItems = filteredNonZeroValueItemsData.slice(0, 3);
  const secondRowItems = filteredNonZeroValueItemsData.slice(3);
  const combinedDataForSecondRow = secondRowItems.concat(restOfThePromotions);

  // Filter Social Promotions from promotions and compare if DATA-SOCIAL
  const returnData = {
    firstRowItems: firstRowItems,
    secondRowItems: combinedDataForSecondRow,
    zeroValueItems: zeroValueItems,
    // filteredPromotionsData: restOfThePromotions
  }
  return returnData
}

Plans.planPromotionFilter = (promotionsData) => {
  // Called from Above Function
  // Parse the data and filter based on AVAILABLE_PLAN_TYPES
  const filteredPromotionData = promotionsData.filter(item => {
    const value = JSON.parse(item.Value);
    return CONSTANTS.AVAILABLE_PLAN_TYPES.includes(value?.Type);
  });

  const transformedData = filteredPromotionData.map(item => {
    const value = JSON.parse(item.Value);
    // Extract specific keys
    return {
      Type: value.Type,
      // Value: 118111600640,
      Value: value.Value,
      Unit: value.Unit,
      IsDouble: value.IsDouble
    };
  });

  // Separate out "DATA-SOCIAL" plan if it exists
  const dataSocial = transformedData.find(item => item.Type === "DATA-SOCIAL");
  const updatedFilteredData = transformedData.filter(item => item.Type !== "DATA-SOCIAL");
  
  const returnData = {
    dataSocialPromotion: dataSocial,
    restOfThePromotions: updatedFilteredData
  }

  return returnData
}

// For Storefront Category Card || Vertical


Plans.sortPlansTypeSequenceVertical = (originalPlanData, promotionsData) => {

  // Filter the transformed data based on AVAILABLE_PLAN_TYPES
  const seenTypes = new Set();
  const plansData = originalPlanData.filter(plan => {
      if (CONSTANTS.AVAILABLE_PLAN_TYPES.includes(plan.Type) && !seenTypes.has(plan.Type)) {
          seenTypes.add(plan.Type);
          return true;
      }
      return false;
  });
  
  const planTypeSequence = () => {
    const plan_type_sequence = Helpers.getPOValue("plan_type_sequence", [])
    return plan_type_sequence
  }

  // All Promotions including DATA-SOCIAL
  const { restOfThePromotions } = Plans.planPromotionFilterVertical(promotionsData);

  // Create a map from planType to its index in the sequence
  const typeIndexMap = planTypeSequence().reduce((map, type, index) => {
      map[type] = index;
      return map;
  }, {});

  // Separate plans into recognized and unrecognized
  const recognizedPlans = [];
  const unrecognizedPlans = [];

  plansData.forEach(plan => {
      if (typeIndexMap.hasOwnProperty(plan.Type)) {
          recognizedPlans.push(plan);
      } else {
          unrecognizedPlans.push(plan);
      }
  });

  // Sort recognized plans based on type index
  const sortedRecognizedPlans = recognizedPlans?.sort((a, b) => {
      return typeIndexMap[a.Type] - typeIndexMap[b.Type];
  });

  // Concatenate sorted recognized plans with unrecognized plans
  const sortedData = sortedRecognizedPlans?.concat(unrecognizedPlans);


  // Map to include only the specified keys
  const transformedData = sortedData?.map(plan => ({
    Type: plan?.Type,
    Value: plan?.Value,
    Unit: plan?.Unit,
  }));

  // Separate out zero-value items
  const zeroValueItems = transformedData.filter(plan => plan.Value === 0);
  const nonZeroValueItems = transformedData.filter(plan => plan.Value !== 0);  
  
  // Now Filter Data-Social items and check if any of it is -1 then keep the -1

  // Check if there's any DATA-SOCIAL plan with Value: -1
  const hasDataSocialWithNegativeValue = nonZeroValueItems.some(plan => 
    plan.Type === "DATA-SOCIAL" && plan.Value === -1
  );

  const filteredNonZeroValueItemsData = nonZeroValueItems.reduce((acc, plan) => {
    // Check if plan is DATA-SOCIAL
    if (plan.Type === "DATA-SOCIAL") {
        // If there is a DATA-SOCIAL plan with Value -1
        if (hasDataSocialWithNegativeValue) {
            // Only keep DATA-SOCIAL plans with Value -1
            if (plan.Value === -1) {
                acc.push(plan);
            }
        } else {
            // No DATA-SOCIAL plans with Value -1
            // Sum the VALUE for DATA-SOCIAL plans
            const existingPlan = acc.find(p => p.Type === "DATA-SOCIAL");
            if (existingPlan) {
                // Update the existing plan's VALUE
                existingPlan.Value += plan.Value;
            } else {
                // Add the new DATA-SOCIAL plan
                acc.push({ ...plan });
            }
        }
    } else {
        // Add non-DATA-SOCIAL plans as they are
        acc.push(plan);
    }
    return acc;
  }, []);

  const firstRowItems = filteredNonZeroValueItemsData.slice(0, 3);
  const secondRowItems = filteredNonZeroValueItemsData.slice(3);
  const combinedDataForSecondRow = secondRowItems.concat(restOfThePromotions);

  // Filter Social Promotions from promotions and compare if DATA-SOCIAL
  const returnData = {
    firstRowItems: firstRowItems,
    secondRowItems: combinedDataForSecondRow,
    zeroValueItems: zeroValueItems,
    // filteredPromotionsData: restOfThePromotions
  }

  return returnData
}

Plans.planPromotionFilterVertical = (promotionsData) => {
  // Called from Above Function
  // Parse the data and filter based on AVAILABLE_PLAN_TYPES
  const filteredPromotionData = promotionsData.filter(item => {
    const value = JSON.parse(item?.Value);
    return CONSTANTS.AVAILABLE_PLAN_TYPES.includes(value?.Type);
  });

  const transformedData = filteredPromotionData.map(item => {
    const value = JSON.parse(item.Value);
    // Extract specific keys
    return {
      Type: value.Type,
      // Value: 118111600640,
      Value: value.Value,
      Unit: value.Unit,
      IsDouble: value.IsDouble
    };
  });

  // Separate out "DATA-SOCIAL" plan if it exists
  const dataSocial = transformedData.find(item => item.Type === "DATA-SOCIAL");
  // const updatedFilteredData = transformedData.filter(item => item.Type !== "DATA-SOCIAL");
  
  const returnData = {
    dataSocialPromotion: dataSocial,
    restOfThePromotions: transformedData
  }

  return returnData
}

export default Plans;